// extracted by mini-css-extract-plugin
export default {"wrapper":"Popover-module--wrapper--e4a5d","greenIcon":"Popover-module--greenIcon--8d366","whiteIcon":"Popover-module--whiteIcon--f7b2b"};